import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const serviceAreas = [
  {
    state: "Washington",
    slug: "washington",
    cities: ["Seattle", "Bellevue", "Tacoma", "Spokane", "Olympia"],
    description: "Serving the greater Seattle metro area and Puget Sound with premium real estate media services.",
    available: true,
  },
  {
    state: "Arkansas",
    slug: "arkansas",
    cities: ["Little Rock", "Conway", "Benton", "Hot Springs", "Fayetteville"],
    description: "Central Arkansas's trusted partner for professional real estate photography and video.",
    available: true,
  },
];

const ServiceAreasSection = () => {
  return (
    <section className="py-24 bg-secondary">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">
            Where We Serve
          </p>
          <h2 className="font-serif text-3xl md:text-5xl font-semibold text-foreground mb-6">
            Service Areas
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Premium real estate media services available in Washington and Arkansas.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {serviceAreas.map((area) => (
            <div 
              key={area.state}
              className="group relative p-8 rounded-lg bg-card border border-border hover:border-primary/50 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-4">
                <MapPin className="text-primary" size={24} />
                <h3 className="font-serif text-2xl font-semibold text-foreground">
                  {area.state}
                </h3>
                {!area.available && (
                  <span className="px-2 py-1 text-xs bg-primary/20 text-primary rounded-full">
                    Coming Soon
                  </span>
                )}
              </div>
              
              <p className="text-muted-foreground mb-6">
                {area.description}
              </p>
              
              <div className="flex flex-wrap gap-2 mb-6">
                {area.cities.map((city) => (
                  <span 
                    key={city}
                    className="px-3 py-1 text-sm bg-muted rounded-full text-muted-foreground"
                  >
                    {city}
                  </span>
                ))}
              </div>
              
              {area.available ? (
                <Link 
                  to={`/${area.slug}`}
                  className="inline-flex items-center text-primary font-medium hover:underline"
                >
                  View {area.state} Services
                  <ArrowRight className="ml-2" size={16} />
                </Link>
              ) : (
                <p className="text-muted-foreground text-sm">
                  Contact us for availability in your area
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceAreasSection;
